import React, { useState, useEffect, useRef } from "react";
import {MegamenuFeaturedImages} from "../../MegamenuFeaturedImages/MegamenuFeaturedImages";
import {MegamenuLinks} from "../../MegamenuLinks/MegamenuLinks";
import useMegamenu from "../../hooks/useMegamenu";
import {MegamenuOverlay} from "../../MegamenuOverlay/MegamenuOverlay";

export const Default = ({
    settings,
    menuItems,
    id,
    layout,
    state
}) => {
    const megamenuRef: any = React.useRef(null); // Reference to the popup container
    const megamenuSM = useMegamenu(megamenuRef, menuItems,settings, false);


    const featuredFlexBasis = 30;

    useEffect(() => {
        const handleMobileMenuClosed = () => megamenuSM.handleMenuClose();
        window.addEventListener("mobile-menu-closed", handleMobileMenuClosed);

        return () => {
            window.removeEventListener("mobile-menu-closed", handleMobileMenuClosed);
        };
    }, [state, id]);

    return (
        <>
            <MegamenuOverlay settings={settings} type={'darken'}/>
            <nav className={`megamenu-nav ${settings.section.container_type} bg-white`} ref={megamenuRef}>
                <div className={`${settings.section.container_type_inner} relative`}>
                    <div className={`megamenu-nav-area flex
                        ${megamenuSM.getPadding(settings.section)}  
                        gap-y-[${settings.section.featured_column_gap_y}px] 
                        ${layout == 'default' && `gap-x-[${settings.section.column_gap_x}px]`}`}
                    >
                        <div className={`megamenu-nav-list flex w-full 
                            ${settings.section.column_spacing} 
                            gap-y-[${settings.section.column_gap_y}px] 
                            ${layout == 'default' && `gap-x-[${settings.section.column_gap_x}px]`}`}
                        >
                            <MegamenuLinks settings={settings} megamenuSM={megamenuSM} />
                        </div>
                        <div className={`megamenu-nav-list flex`} style={{ flexBasis: `${featuredFlexBasis}%`}}>
                            <MegamenuFeaturedImages settings={settings} megamenuSM={megamenuSM} />
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Default;
